<div class="p-3">
  <p class="h3 text-secondary-defaut" mat-dialog-title>
    <i class="bi bi-exclamation-circle-fill me-2"></i>Sessão Expirada
  </p>
  <mat-dialog-content
    >Sua sessão expirou por questões de segurança. Por favor, faça login novamente para continuar acessando o
    sistema.</mat-dialog-content
  >
  <mat-dialog-actions>
    <app-button buttonClass="bt-danger" mat-button mat-dialog-close>Fechar</app-button>
  </mat-dialog-actions>
</div>
